import React from "react";
import { useQuery } from "react-apollo";
import { useTranslation } from "react-i18next";

import { fields } from "../../lib/translation/strings";

import { ProductProps } from "../../types/productTypes";
import { GET_RELATED_PRODUCTS, GetRelatedProductsVariables } from "../../queries/archive";
import { useProductCategoryFilter } from "../../lib/hooks/useProductCategoryFilter";

import { BulkLoader } from "../shared/BulkLoader/BulkLoader";
import { Product } from "../ListOfProducts/Product";
import { Alert } from "../Notifications/Alert";
import { RelatedProductsLoader } from "./RelatedProductsLoader";

import "./RelatedProducts.scss";

interface Props {
  excludedID?: number;
  category: string;
}

export const RelatedProducts = (props: Props) => {
  const { t } = useTranslation();
  const categoryFilter = useProductCategoryFilter();
  const relatedProducts = useQuery<any, GetRelatedProductsVariables>(GET_RELATED_PRODUCTS, {
    variables: {
      exclude: props.excludedID ? [props.excludedID] : undefined,
      category: props.category,
      categoryIn: categoryFilter?.map(id => parseInt(id, 10)),
    },
  });

  if (relatedProducts.loading) {
    return (
      <div className="RelatedProducts">
        <div className="RelatedProducts__list">
          <BulkLoader length={7} component={RelatedProductsLoader} />
        </div>
      </div>
    );
  }

  if (relatedProducts.error) {
    return <Alert type="danger" message={relatedProducts.error.message} />;
  }

  return (
    <div className="RelatedProducts">
      {relatedProducts.data?.products?.nodes?.length > 0 && (
        <>
          <h3 className="RelatedProducts__title">
            {t(fields.relatedProducts)}
          </h3>
          <div className="RelatedProducts__list">
            {relatedProducts.data?.products?.nodes?.map(
              (item: ProductProps) => {
                return <Product key={item.id} product={item} />;
              }
            )}
          </div>
        </>
      )}
    </div>
  );
};
